import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import { ModalProfileComponent } from '../modal-profile/modal-profile.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { TooltipPosition } from '@angular/material';
import { ILoggedUser } from '../interfaces/loggedUser';

@Component({
  selector: 'app-modal-edit-profile',
  templateUrl: './modal-edit-profile.component.html',
  styleUrls: ['./modal-edit-profile.component.css']
})
export class ModalEditProfileComponent implements OnInit {

  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  @Input() userLogged: ILoggedUser;

  public isCollapsed = true;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  passwordPattern = '^[A-Z][a-z]{7,}';
  formPattern = '[A-Za-z]{1,}';

  oldLocal = localStorage.getItem('localUser');
  itemLocal = JSON.parse(this.oldLocal);
  UserName = this.itemLocal.userName;

  positionOptions: TooltipPosition[] = ['above'];
  position = new FormControl(this.positionOptions[0]);
  profileImgURL: any;

  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    private modal: NgbActiveModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.profileImgURL = this.userLogged.ProfileImg ? this.userLogged.ProfileImgURL : '../../assets/image/gender_neutral_user_80px.png';
  }
  // Method used to close modal edit Profile.
  close() {
    this.modal.close();
  }

  // Api update user.
  OnSubmit(Nome, Cognome, Telefono) {
    const Id = this.userLogged.Id;
    // Call Api of user service used to update user.
    this.userService.usersUpdate(Id, Nome, Cognome, Telefono)
      .subscribe(
        data => {
          this.translate.get('CODE_200_EDIT_PROFILE.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          });
          this.modal.close();
          const modalRef = this.modalService.open(ModalProfileComponent, { centered: true });
          modalRef.componentInstance.userLogged = this.userLogged;
        },
        error => {
          if (error.status === 400) {
            this.translate.get('CODE_400_EDIT_PROFILE.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              });
            });

          } else {
            this.router.navigate(['/errorPage']);
          }
          throw error;
        });
  }

  // Api update password
  editPassword(OldPassword, NewPassword) {
    const Id = this.userLogged.Id;

    // Call Api of user service that upadate password of current user.
    this.userService.usersUpdatePassword(Id, OldPassword, NewPassword)
      .subscribe(
        data => {
          this.translate.get('CODE_200_EDIT_PASSWORD.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          });
          this.modal.close();
          const modalRef = this.modalService.open(ModalProfileComponent, { centered: true });
          modalRef.componentInstance.userLogged = this.userLogged;
        },
        error => {
          if (error.status === 400) {
            this.translate.get('CODE_400_EDIT_PASSWORD.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              });
            });

          } else if (error.status === 406) {
            this.toastr.error(error.error.ErrorMessage, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            });

          } else {
            this.router.navigate(['/errorPage']);
          }
          throw error;
        });
  }

  onFileChanged(files: File[]) {
    if (!files.length) { return; }
    const file: File = files[0];

    this.userService.uploadImgProfile(file, this.userLogged.Id).subscribe(data => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.userLogged.ProfileImg = file.name;
        this.profileImgURL = this.userLogged.ProfileImgURL = event.target.result;
      };
    }, error => {
      if (error.status === 409) {
        this.translate.get('CODE_409_IMAGE_PROFILE.TITLE').subscribe((res: string) => {
          this.toastr.error(res, null, {
            positionClass: 'toast-top-center',
            timeOut: 2000
          });
        });
      } else {
        this.toastr.error('Error', null, {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
      }
    });
  }

  removeProfileImage() {
    this.userService.removeImgProfile(this.userLogged.Id).subscribe(data => {
      this.userLogged.ProfileImg = undefined;
      this.profileImgURL = '../../assets/image/gender_neutral_user_80px.png';
      this.userLogged.ProfileImgURL = '../../assets/image/Profile.png';
    }, error => {
      this.toastr.error('Error', null, {
        positionClass: 'toast-top-center',
        timeOut: 2000
      });
    });
  }
}
